import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UrlMetaService {
  url: string;
  constructor(private http: HttpClient) {
    this.url = environment.apiUrl;
  }

  GetListMetaData(url: string[]) {
    return this.http.post(`${this.url}UrlMetaDate/GetListMetaData`, url);
  }
}
